var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitchLite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45005 26.8279C4.45005 27.2267 4.77333 27.55 5.17215 27.55H26.8278C27.2261 27.55 27.5491 27.2275 27.5498 26.8294V5.17033C27.5491 4.77331 27.2273 4.45128 26.8296 4.45005H5.17064C4.773 4.45128 4.45005 4.77402 4.45005 5.17226V26.8279ZM5.17215 28.4501C4.27627 28.4501 3.55005 27.7238 3.55005 26.8279V5.17226C3.55005 4.27732 4.27452 3.55177 5.16891 3.55005H26.8305C27.7234 3.55177 28.4481 4.27471 28.4498 5.1686V26.8303C28.4481 27.7247 27.7226 28.4501 26.8278 28.4501H5.17215Z",
    fill: "url(#hinava_random_uuid_136494608177131663988921924394875586359)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5474 26.6955C13.5342 26.6902 13.5162 26.6732 13.5082 26.6579C13.5022 26.6471 13.5013 26.6179 13.5002 26.3643C13.4994 26.1755 13.5006 26.0756 13.5034 26.062C13.5094 26.0332 13.5346 26.008 13.5606 26.0053C13.5874 26.002 13.6058 26.0068 13.6218 26.0208C13.649 26.0448 13.6494 26.0459 13.6506 26.1671L13.6518 26.2759H14.1393V26.1679C14.1393 26.0692 14.1402 26.0584 14.1469 26.0448C14.1613 26.0164 14.1817 26.004 14.2138 26.004C14.2477 26.004 14.2741 26.0236 14.2833 26.0552C14.2865 26.0652 14.2874 26.1608 14.2865 26.3599L14.2853 26.6499L14.2762 26.6651C14.2541 26.6999 14.2089 26.7102 14.1742 26.6883C14.1406 26.6667 14.1393 26.6612 14.1393 26.536V26.4279H13.6518L13.6506 26.5371C13.6494 26.6431 13.649 26.6463 13.6401 26.6612C13.6246 26.6854 13.6061 26.6971 13.5802 26.6987C13.5674 26.6991 13.553 26.6979 13.5474 26.6955Z",
    fill: "url(#hinava_random_uuid_294631706081214086952814756879517066194)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4573 26.6935C14.4385 26.684 14.4236 26.6675 14.4189 26.6519C14.4161 26.6428 14.4152 26.5368 14.4161 26.3412L14.4173 26.0444L14.4329 26.0284C14.4525 26.0083 14.4696 26.0025 14.4989 26.0053C14.5189 26.0073 14.5233 26.0096 14.5381 26.0252C14.5469 26.0348 14.5565 26.05 14.5589 26.0585C14.5649 26.0796 14.5649 26.6239 14.5589 26.6451C14.5537 26.6639 14.5337 26.6875 14.5165 26.6944C14.4993 26.7019 14.472 26.7012 14.4573 26.6935Z",
    fill: "url(#hinava_random_uuid_90546512927507509904142530129260975921)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7298 26.694C14.7138 26.6851 14.7007 26.6724 14.6926 26.658C14.6867 26.6472 14.6858 26.6193 14.6858 26.366C14.6858 26.1408 14.687 26.0832 14.6915 26.0708C14.6943 26.0624 14.7063 26.0456 14.7179 26.034C14.7451 26.0073 14.769 25.998 14.8083 26.0008C14.8446 26.0037 14.8606 26.0137 14.9094 26.0644C14.9314 26.0873 14.9718 26.1296 14.9994 26.158C15.027 26.1868 15.0866 26.2488 15.1318 26.296C15.177 26.3432 15.2382 26.4072 15.2678 26.4381L15.3218 26.494L15.3237 26.272C15.3254 26.0761 15.3266 26.0488 15.3321 26.038C15.3562 25.9944 15.4182 25.9869 15.4526 26.0228C15.4586 26.0288 15.4654 26.0393 15.4674 26.0452C15.4706 26.0528 15.4718 26.1485 15.4718 26.3365C15.4718 26.6496 15.4734 26.6316 15.4425 26.6632C15.4198 26.6872 15.399 26.6967 15.3674 26.6992C15.327 26.7019 15.3022 26.6892 15.257 26.6428C15.2078 26.5915 15.0482 26.4252 15.0342 26.4103C15.019 26.394 14.9458 26.318 14.885 26.2552L14.8359 26.2049V26.6412L14.827 26.6592C14.815 26.6832 14.7926 26.6971 14.7638 26.6987C14.7491 26.7 14.7379 26.6984 14.7298 26.694Z",
    fill: "url(#hinava_random_uuid_52346399482214013955685137672792999696)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7459 26.6903C15.6459 26.658 15.584 26.5584 15.5999 26.4559C15.6139 26.3652 15.6887 26.2916 15.7779 26.28C15.8143 26.2752 16.217 26.2752 16.2375 26.2796C16.2543 26.2836 16.2772 26.3032 16.2866 26.3217C16.2907 26.3297 16.2923 26.3408 16.2911 26.3564C16.2891 26.3827 16.2774 26.4016 16.253 26.4168L16.2378 26.426L16.0099 26.428C15.7515 26.4304 15.7663 26.4284 15.7511 26.4629C15.7411 26.4861 15.7431 26.5072 15.7579 26.5264C15.7783 26.5532 15.7711 26.5523 16.0291 26.5513L16.2618 26.55L16.2858 26.5403C16.3418 26.518 16.3834 26.4768 16.4055 26.4228C16.4155 26.3981 16.4166 26.3892 16.4166 26.3524C16.4171 26.3152 16.4155 26.3064 16.4059 26.282C16.3826 26.2233 16.3395 26.1812 16.2814 26.1611C16.2639 26.1553 16.2327 26.154 15.9899 26.1521C15.6843 26.1496 15.7035 26.1517 15.6799 26.1192C15.6695 26.1048 15.6679 26.0996 15.6679 26.0753C15.6679 26.0488 15.6683 26.0473 15.6839 26.0305C15.6927 26.0208 15.7052 26.0109 15.7112 26.0083C15.7196 26.0048 15.7979 26.0041 16.0043 26.0048L16.2858 26.006L16.323 26.0193C16.3847 26.0404 16.4327 26.0721 16.4758 26.1192C16.491 26.1364 16.5038 26.1532 16.5038 26.1532C16.5038 26.1553 16.5082 26.1624 16.5135 26.1692C16.5278 26.1885 16.5455 26.2295 16.5558 26.268C16.569 26.316 16.5694 26.384 16.5562 26.434C16.523 26.5616 16.4198 26.6632 16.2934 26.6916C16.2586 26.6996 16.2459 26.7 16.0155 26.7C15.7755 26.6996 15.7739 26.6996 15.7459 26.6903Z",
    fill: "url(#hinava_random_uuid_335207605804176197004054433848708483142)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.987 26.6963C16.9597 26.6871 16.9369 26.6732 16.9206 26.6543C16.9054 26.6371 16.819 26.486 16.7365 26.332C16.7277 26.3156 16.7077 26.2796 16.6922 26.2519C16.619 26.1216 16.6069 26.0972 16.6069 26.0788C16.6069 26.0408 16.6365 26.0083 16.6746 26.0048C16.715 26.0012 16.7374 26.0183 16.769 26.078C16.8158 26.1656 17.0181 26.5328 17.0221 26.5368C17.0242 26.5387 17.0293 26.5323 17.0341 26.5232C17.0389 26.5135 17.0486 26.496 17.0553 26.4839C17.0621 26.472 17.0741 26.4503 17.0821 26.4359C17.1174 26.3707 17.1913 26.2359 17.225 26.1759C17.2449 26.1395 17.2702 26.094 17.2805 26.074C17.3105 26.018 17.3272 26.004 17.3657 26.004C17.3897 26.004 17.4089 26.0137 17.4245 26.0332C17.4357 26.0472 17.4369 26.0511 17.4369 26.0772L17.4365 26.106L17.3973 26.1759C17.3633 26.2368 17.2792 26.3887 17.2334 26.4731C17.2253 26.488 17.2153 26.506 17.2113 26.5132C17.2073 26.5204 17.1982 26.5368 17.1909 26.5499C17.1837 26.5631 17.1744 26.5796 17.1709 26.5859C17.1673 26.5928 17.1593 26.6071 17.1534 26.6179C17.1377 26.6463 17.1086 26.6751 17.0829 26.6871C17.0657 26.6951 17.0537 26.698 17.029 26.6987C17.0113 26.6991 16.9926 26.6984 16.987 26.6963Z",
    fill: "url(#hinava_random_uuid_11704901319893557600844238242424924181)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6419 26.694C17.5895 26.6796 17.5375 26.6393 17.5111 26.5932C17.4375 26.4644 17.5211 26.2976 17.6683 26.2796C17.6887 26.2772 17.7863 26.276 17.9163 26.2769L18.1307 26.278L18.1463 26.2904C18.1547 26.2972 18.1655 26.3097 18.1703 26.3184C18.1934 26.3584 18.1691 26.4103 18.1215 26.4236C18.1108 26.4264 18.0331 26.428 17.8892 26.428H17.6726L17.6591 26.4372C17.6211 26.4624 17.6236 26.5212 17.6636 26.5435C17.6783 26.5519 17.6819 26.5519 17.9039 26.5519C18.1423 26.5519 18.1459 26.5516 18.1891 26.5328C18.233 26.5132 18.2707 26.4736 18.2903 26.426C18.3019 26.3984 18.3046 26.3827 18.3042 26.348C18.3042 26.2765 18.2627 26.2092 18.1975 26.1748C18.1547 26.1521 18.1523 26.1521 17.8715 26.1521C17.6291 26.1521 17.6127 26.1512 17.5975 26.1444C17.5427 26.1192 17.5367 26.0536 17.5859 26.0153L17.5975 26.006H18.1734L18.2055 26.0172C18.2543 26.0344 18.2855 26.0516 18.321 26.0804C18.3606 26.1125 18.3894 26.1472 18.413 26.1921C18.4387 26.2408 18.4478 26.276 18.4503 26.3368C18.4523 26.3804 18.451 26.3932 18.4435 26.4268C18.4387 26.4484 18.4275 26.4804 18.4191 26.498C18.4003 26.5372 18.3983 26.54 18.373 26.5704C18.3246 26.6292 18.2655 26.6679 18.1934 26.6892C18.1667 26.6971 18.1547 26.6976 17.9135 26.6984C17.7095 26.6992 17.658 26.6984 17.6419 26.694Z",
    fill: "url(#hinava_random_uuid_136847448448762523755296520597578536688)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.709 13.2388C10.5439 13.2388 10.4099 13.1048 10.4099 12.9398V9.64925C10.4099 9.4839 10.5439 9.34992 10.709 9.34992C10.8741 9.34992 11.008 9.4839 11.008 9.64925V12.9398C11.008 13.1048 10.8741 13.2388 10.709 13.2388Z",
    fill: "url(#hinava_random_uuid_3184378696728012877383486273825105560)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8413 13.2388C21.6762 13.2388 21.5422 13.1048 21.5422 12.9398V9.64925C21.5422 9.4839 21.6762 9.34992 21.8413 9.34992C22.0064 9.34992 22.1404 9.4839 22.1404 9.64925V12.9398C22.1404 13.1048 22.0064 13.2388 21.8413 13.2388Z",
    fill: "url(#hinava_random_uuid_197481575832630272329484265640699189920)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8691 13.2388C20.704 13.2388 20.5701 13.1048 20.5701 12.9398V9.64925C20.5701 9.4839 20.704 9.34992 20.8691 9.34992C21.0342 9.34992 21.1682 9.4839 21.1682 9.64925V12.9398C21.1682 13.1048 21.0342 13.2388 20.8691 13.2388Z",
    fill: "url(#hinava_random_uuid_327147270386182315477439014653276317888)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7112 22.6589C10.5461 22.6589 10.4121 22.5249 10.4121 22.3598V19.0693C10.4121 18.904 10.5461 18.77 10.7112 18.77C10.8763 18.77 11.0102 18.904 11.0102 19.0693V22.3598C11.0102 22.5249 10.8763 22.6589 10.7112 22.6589Z",
    fill: "url(#hinava_random_uuid_35146711369098422045746027833086469195)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73901 22.6589C9.57392 22.6589 9.43994 22.5249 9.43994 22.3598V19.0693C9.43994 18.904 9.57392 18.77 9.73901 18.77C9.90409 18.77 10.0381 18.904 10.0381 19.0693V22.3598C10.0381 22.5249 9.90409 22.6589 9.73901 22.6589Z",
    fill: "url(#hinava_random_uuid_113190976806901443767261597315396395233)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6833 22.6589C11.5183 22.6589 11.3843 22.5249 11.3843 22.3598V19.0693C11.3843 18.904 11.5183 18.77 11.6833 18.77C11.8484 18.77 11.9824 18.904 11.9824 19.0693V22.3598C11.9824 22.5249 11.8484 22.6589 11.6833 22.6589Z",
    fill: "url(#hinava_random_uuid_193724083964390020974536340420595176624)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8713 22.6589C20.7062 22.6589 20.5723 22.5249 20.5723 22.3598V19.0693C20.5723 18.904 20.7062 18.77 20.8713 18.77C21.0364 18.77 21.1704 18.904 21.1704 19.0693V22.3598C21.1704 22.5249 21.0364 22.6589 20.8713 22.6589Z",
    fill: "url(#hinava_random_uuid_5936846543038981213655012031217166576)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8992 22.6589C19.7341 22.6589 19.6001 22.5249 19.6001 22.3598V19.0693C19.6001 18.904 19.7341 18.77 19.8992 18.77C20.0642 18.77 20.1982 18.904 20.1982 19.0693V22.3598C20.1982 22.5249 20.0642 22.6589 19.8992 22.6589Z",
    fill: "url(#hinava_random_uuid_118587427585306084075882958895026744502)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8157 22.6589C22.6506 22.6589 22.5166 22.5249 22.5166 22.3598V19.0693C22.5166 18.904 22.6506 18.77 22.8157 18.77C22.9808 18.77 23.1147 18.904 23.1147 19.0693V22.3598C23.1147 22.5249 22.9808 22.6589 22.8157 22.6589Z",
    fill: "url(#hinava_random_uuid_112886779910280036559124582137115608565)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8435 22.6589C21.6784 22.6589 21.5444 22.5249 21.5444 22.3598V19.0693C21.5444 18.904 21.6784 18.77 21.8435 18.77C22.0086 18.77 22.1426 18.904 22.1426 19.0693V22.3598C22.1426 22.5249 22.0086 22.6589 21.8435 22.6589Z",
    fill: "url(#hinava_random_uuid_329436790020854146796151000472294215811)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_136494608177131663988921924394875586359",
    x1: 15.9999,
    y1: 3.55005,
    x2: 15.9999,
    y2: 28.4501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_294631706081214086952814756879517066194",
    x1: 13.8934,
    y1: 26.004,
    x2: 13.8934,
    y2: 26.6998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_90546512927507509904142530129260975921",
    x1: 14.4896,
    y1: 26.0046,
    x2: 14.4896,
    y2: 26.6997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_52346399482214013955685137672792999696",
    x1: 15.0788,
    y1: 26,
    x2: 15.0788,
    y2: 26.6996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_335207605804176197004054433848708483142",
    x1: 16.0817,
    y1: 26.0045,
    x2: 16.0817,
    y2: 26.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_11704901319893557600844238242424924181",
    x1: 17.0219,
    y1: 26.004,
    x2: 17.0219,
    y2: 26.6988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_136847448448762523755296520597578536688",
    x1: 17.9675,
    y1: 26.006,
    x2: 17.9675,
    y2: 26.6987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_3184378696728012877383486273825105560",
    x1: 10.709,
    y1: 13.2388,
    x2: 10.709,
    y2: 9.34992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_197481575832630272329484265640699189920",
    x1: 21.8413,
    y1: 13.2388,
    x2: 21.8413,
    y2: 9.34992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_327147270386182315477439014653276317888",
    x1: 20.8691,
    y1: 13.2388,
    x2: 20.8691,
    y2: 9.34992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_35146711369098422045746027833086469195",
    x1: 10.7112,
    y1: 22.6589,
    x2: 10.7112,
    y2: 18.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_113190976806901443767261597315396395233",
    x1: 9.73901,
    y1: 22.6589,
    x2: 9.73901,
    y2: 18.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_193724083964390020974536340420595176624",
    x1: 11.6833,
    y1: 22.6589,
    x2: 11.6833,
    y2: 18.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_5936846543038981213655012031217166576",
    x1: 20.8713,
    y1: 22.6589,
    x2: 20.8713,
    y2: 18.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_118587427585306084075882958895026744502",
    x1: 19.8992,
    y1: 22.6589,
    x2: 19.8992,
    y2: 18.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_112886779910280036559124582137115608565",
    x1: 22.8157,
    y1: 22.6589,
    x2: 22.8157,
    y2: 18.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_329436790020854146796151000472294215811",
    x1: 21.8435,
    y1: 22.6589,
    x2: 21.8435,
    y2: 18.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchLite);
export default __webpack_public_path__ + "static/media/switch-lite.8c614da140eadc80f27c3836447ced9b.svg";
export { ForwardRef as ReactComponent };